module.exports = __webpack_public_path__ + "img/2026.90fbb556.jpg";